// Pure form validation keeps error messages and phone rules identical across renders.
export function validatePerson(form, emailMessage) {
  const errors = {};
  if (form.name.trim().length < 2) errors.name = "Please enter your name.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = emailMessage;
  if (!form.phone.trim()) errors.phone = "Phone number is required.";
  else if (!/^\d{7,14}$/.test(form.phone)) errors.phone = "Enter a valid phone number.";
  return errors;
}

export function validateInquiry(form, pathId) {
  const errors = validatePerson(form, "Enter a valid email address.");
  if (pathId === "employer" && form.organisation.trim().length < 2) {
    errors.organisation = "Please enter your company name.";
  }
  return errors;
}

export function validateContact(form) {
  const errors = validatePerson(form, "Enter a valid email.");
  if (form.message.trim().length < 10) errors.message = "Please add a little more detail.";
  return errors;
}